// 吃瓜新闻 - 首页演示数据（静态展示用，不连接数据库）
export type Article = {
  id: string;
  category: string;
  tag: string;
  title: string;
  summary: string;
  time: string;
  read: string;
  image: string;
  author: string;
};

export const hotList = [
  { rank: 1, heat: '128万', title: '一纸公告背后：头部综艺“停更风波”的来龙去脉', trend: 'up' },
  { rank: 2, heat: '96万', title: '“行业黑幕”视频刷屏，制片方连夜回应，谁在蹭热度？', trend: 'up' },
  { rank: 3, heat: '88万', title: '顶流演唱会一票难求，黄牛产业链如何层层加价', trend: 'same' },
  { rank: 4, heat: '71万', title: '老牌明星直播带货翻车现场，是演技还是剧本？', trend: 'down' },
  { rank: 5, heat: '64万', title: '幕后经纪人讲述：一部剧从立项到过审要走多久', trend: 'up' },
  { rank: 6, heat: '52万', title: '“塌房”传言满天飞，我们核查了三个月前的原始素材', trend: 'up' },
  { rank: 7, heat: '47万', title: '县城青年涌入短视频做“吃瓜主播”，月入过万背后', trend: 'same' },
  { rank: 8, heat: '39万', title: '品牌与艺人的“解约文学”：合同里的违约金真相', trend: 'down' },
];

export const breaking = {
  tag: '独家首发',
  kicker: '深度报道 · 争议背后',
  title: '“反转再反转”：一场网络维权事件，我们拆解出完整时间线',
  summary:
    '从控诉到辟谣再到沉默，各执一词的信息不断冲上热搜。记者梳理公开声明与关键时间节点，还原事件如何一步步失控，也追问：围观过后，谁能给出确凿结论。',
  author: '编辑部 · 追瓜组',
  time: '今日 09:12',
  image:
    'https://readdy.ai/api/search-image?query=editorial%20press%20conference%20scene%20with%20blurred%20reporters%20and%20microphones%20in%20warm%20golden%20ambient%20light%2C%20dark%20cinematic%20background%2C%20professional%20photojournalism%20atmosphere%2C%20high%20contrast%2C%20warm%20tone&width=1600&height=900&seq=breaking-2026-1&orientation=landscape',
};

export const deepReports: Article[] = [
  {
    id: 'deep-1',
    category: '深度报道',
    tag: '事件复盘',
    title: '一场“直播带货翻车”里的多方角力，谁该为虚假宣传负责',
    summary:
      '当主播、平台与品牌方各执一词时，责任往往被层层推诿。我们走访前从业者，还原一次典型的“翻车”是如何被策划、发酵，又被轻描淡写地带过。',
    time: '2 小时前',
    read: '12 分钟',
    author: '陈晓棠',
    image:
      'https://readdy.ai/api/search-image?query=newsroom%20editorial%20desk%20with%20newspapers%20and%20monitor%20showing%20live%20stream%20in%20warm%20lighting%2C%20documentary%20photography%2C%20muted%20editorial%20tones&width=800&height=520&seq=deep1-2026-1&orientation=landscape',
  },
  {
    id: 'deep-2',
    category: '深度报道',
    tag: '行业观察',
    title: '“吃瓜”是怎么变成一门生意的：拆解内容搬运的灰色链条',
    summary:
      '热搜背后，有专门团队负责选题、剪辑与情绪煽动。我们追踪一套爆款公式如何被复制，也讨论在流量与事实之间，创作者应守住怎样的底线。',
    time: '5 小时前',
    read: '9 分钟',
    author: '周牧野',
    image:
      'https://readdy.ai/api/search-image?query=dark%20modern%20newsroom%20with%20blurred%20screens%20of%20trending%20feeds%20and%20analytics%2C%20moody%20editorial%20lighting%2C%20photojournalism&width=800&height=520&seq=deep2-2026-1&orientation=landscape',
  },
];

export const exclusiveInterviews: Article[] = [
  {
    id: 'ex-1',
    category: '独家专访',
    tag: '人物侧写',
    title: '专访从业二十年的节目制片人：那些“名场面”都是怎么被选出来的',
    summary:
      '在镜头之外，选角、剪辑与话题制造都有一套成熟方法论。制片人坦言，很多被热议的“冲突”并非偶然，而是节目组在流程中精心设计过的选择。',
    time: '昨天 20:30',
    read: '18 分钟',
    author: '许子墨',
    image:
      'https://readdy.ai/api/search-image?query=dim%20television%20studio%20set%20with%20soft%20spotlight%20and%20professional%20camera%20silhouette%2C%20cinematic%20interview%20atmosphere%2C%20warm%20dramatic%20lighting%2C%20editorial&width=900&height=620&seq=ex1-2026-1&orientation=landscape',
  },
  {
    id: 'ex-2',
    category: '独家专访',
    tag: '行业揭秘',
    title: '一位“舆情顾问”的坦白：热搜是真的，还是可以设计出来的',
    summary:
      '从热词预埋到情绪引导，公关行业有一套通行的操作流程。受访者用不点名的方式讲述行业惯例，并提醒读者：下次看到“爆了”，不妨多想一层。',
    time: '昨天 14:10',
    read: '15 分钟',
    author: '林一舟',
    image:
      'https://readdy.ai/api/search-image?query=minimalist%20radio%20microphone%20on%20wooden%20table%20in%20a%20quiet%20recording%20booth%2C%20warm%20editorial%20photography%2C%20soft%20window%20light&width=900&height=620&seq=ex2-2026-1&orientation=landscape',
  },
];

export const categories: string[] = ['娱乐', '人物', '行业', '现场'];

export const categoryArticles: Record<string, Article[]> = {
  娱乐: [
    {
      id: 'cat-1',
      category: '娱乐',
      tag: '影视圈',
      title: '续集口碑扑街？我们和编剧聊了聊“剧本被改”的真实原因',
      summary: '当资本与创作发生冲突，最终呈现往往是多方妥协的结果。',
      time: '今日 07:40',
      read: '6 分钟',
      author: '南栀',
      image:
        'https://readdy.ai/api/search-image?query=film%20clapperboard%20and%20script%20pages%20on%20director%20desk%20with%20warm%20cinema%20light%2C%20editorial%20photography%2C%20behind%20the%20scenes&width=640&height=420&seq=cat-a1-2026&orientation=landscape',
    },
    {
      id: 'cat-2',
      category: '娱乐',
      tag: '音综',
      title: '一档音乐综艺为何能“圈粉”出圈？解码制作组的选曲逻辑',
      summary: '从冷门好歌到情怀杀，每一首被刷屏的翻唱都有讲究。',
      time: '昨日 22:15',
      read: '5 分钟',
      author: '乔安',
      image:
        'https://readdy.ai/api/search-image?query=concert%20stage%20with%20golden%20spotlights%20and%20blurred%20audience%20silhouettes%2C%20warm%20atmospheric%20concert%20photography&width=640&height=420&seq=cat-a2-2026&orientation=landscape',
    },
    {
      id: 'cat-3',
      category: '娱乐',
      tag: '片场故事',
      title: '实拍揭秘：剧组一天是怎么被“赶工”出来的',
      summary: '灯光、布景、走位，一场看似简单戏的背后是几十人的调度。',
      time: '昨日 16:50',
      read: '8 分钟',
      author: '南栀',
      image:
        'https://readdy.ai/api/search-image?query=movie%20film%20set%20with%20lighting%20equipment%20and%20director%20chair%20silhouette%2C%20warm%20behind%20the%20scenes%20editorial%20photo&width=640&height=420&seq=cat-a3-2026&orientation=landscape',
    },
  ],
  人物: [
    {
      id: 'cat-4',
      category: '人物',
      tag: '人物特稿',
      title: '在片场跑了八年龙套的演员：我见过太多“一夜爆红”的背面',
      summary: '聚光灯之外，更多默默等待的人仍在坚持表演这件事本身。',
      time: '今日 06:20',
      read: '10 分钟',
      author: '陈晓棠',
      image:
        'https://readdy.ai/api/search-image?query=lonely%20actor%20silhouette%20standing%20backstage%20in%20warm%20theater%20light%2C%20editorial%20documentary%20photography&width=640&height=420&seq=cat-b1-2026&orientation=landscape',
    },
    {
      id: 'cat-5',
      category: '人物',
      tag: '幕后人物',
      title: '一位选角导演的日常：每天要看多少张脸，才能挑中“那个人”',
      summary: '大众以为的“星探”，其实是一份需要极度耐心的案头工作。',
      time: '昨日 19:30',
      read: '7 分钟',
      author: '周牧野',
      image:
        'https://readdy.ai/api/search-image?query=casting%20audition%20room%20with%20headshots%20on%20table%20and%20blurred%20camera%2C%20warm%20editorial%20documentary%20style&width=640&height=420&seq=cat-b2-2026&orientation=landscape',
    },
    {
      id: 'cat-6',
      category: '人物',
      tag: '素人逆袭',
      title: '从工厂流水线到百万粉丝主播，她只做了这一件事',
      summary: '偶然入场的普通人，如何抓住内容时代的窗口完成转身。',
      time: '昨日 11:45',
      read: '9 分钟',
      author: '林一舟',
      image:
        'https://readdy.ai/api/search-image?query=young%20creator%20recording%20content%20with%20smartphone%20ring%20light%20in%20cozy%20room%2C%20warm%20modern%20lifestyle%20photography&width=640&height=420&seq=cat-b3-2026&orientation=landscape',
    },
  ],
  行业: [
    {
      id: 'cat-7',
      category: '行业',
      tag: '营销内幕',
      title: '“热搜预定”的成本是多少？解密一套标准的投放报价单',
      summary: '从话题词到话题热度，行业里早已有成熟的明码标价。',
      time: '今日 08:05',
      read: '8 分钟',
      author: '林一舟',
      image:
        'https://readdy.ai/api/search-image?query=spreadsheet%20and%20laptop%20showing%20marketing%20dashboard%20on%20desk%2C%20moody%20editorial%20business%20photography%20warm%20light&width=640&height=420&seq=cat-c1-2026&orientation=landscape',
    },
    {
      id: 'cat-8',
      category: '行业',
      tag: '选秀幕后',
      title: '偶像产业炼成记：出道即巅峰之后，路要怎么走',
      summary: '数据与热度退潮后，真正的考验才刚刚开始。',
      time: '昨日 23:00',
      read: '11 分钟',
      author: '许子墨',
      image:
        'https://readdy.ai/api/search-image?query=empty%20dance%20rehearsal%20studio%20with%20mirrors%20and%20warm%20practical%20lights%2C%20editorial%20documentary%20photography&width=640&height=420&seq=cat-c2-2026&orientation=landscape',
    },
    {
      id: 'cat-9',
      category: '行业',
      tag: '版权观察',
      title: '短视频二创的边界在哪里？从业者与法务的视角碰撞',
      summary: '一边是流量狂欢，一边是版权红线，规则仍在磨合之中。',
      time: '昨日 15:20',
      read: '7 分钟',
      author: '南栀',
      image:
        'https://readdy.ai/api/search-image?query=video%20editing%20timeline%20on%20screen%20with%20warm%20desk%20lamp%2C%20creative%20editorial%20workspace%20photography&width=640&height=420&seq=cat-c3-2026&orientation=landscape',
    },
  ],
  现场: [
    {
      id: 'cat-10',
      category: '现场',
      tag: '一线直击',
      title: '我们挤进发布会前排，拍下明星们未摆拍的真实瞬间',
      summary: '红毯之外，记者席才是观察人物另一面的最佳位置。',
      time: '今日 05:50',
      read: '6 分钟',
      author: '乔安',
      image:
        'https://readdy.ai/api/search-image?query=crowd%20of%20photographers%20with%20cameras%20at%20a%20press%20event%2C%20warm%20flash%20lighting%2C%20editorial%20photojournalism&width=640&height=420&seq=cat-d1-2026&orientation=landscape',
    },
    {
      id: 'cat-11',
      category: '现场',
      tag: '街采',
      title: '街头采访：路人眼中的“吃瓜”，到底图个什么',
      summary: '有人图热闹，有人追真相，也有人只是需要一个谈资。',
      time: '昨日 18:40',
      read: '5 分钟',
      author: '周牧野',
      image:
        'https://readdy.ai/api/search-image?query=handheld%20microphone%20held%20toward%20blurred%20city%20street%20crowd%20at%20golden%20hour%2C%20warm%20street%20documentary%20photography&width=640&height=420&seq=cat-d2-2026&orientation=landscape',
    },
    {
      id: 'cat-12',
      category: '现场',
      tag: '现场见闻',
      title: '演唱会开场前两小时：我们看到了比舞台更热闹的场外',
      summary: '从应援大军到周边商贩，演唱会早已不只是音乐本身。',
      time: '昨日 21:10',
      read: '7 分钟',
      author: '乔安',
      image:
        'https://readdy.ai/api/search-image?query=stadium%20exterior%20crowd%20holding%20light%20sticks%20at%20night%2C%20warm%20city%20lights%2C%20concert%20fan%20culture%20editorial%20photo&width=640&height=420&seq=cat-d3-2026&orientation=landscape',
    },
  ],
};

export const topics: Article[] = [
  {
    id: 'topic-1',
    category: '吃瓜话题',
    tag: '#塌房考究局',
    title: '“塌房”考究局：明星人设崩塌背后的产业级套路',
    summary:
      '当一份声明需要反复修改措辞，当一段“道歉”被逐字分析，人设的崩塌往往早有预兆。专题整理近年案例的共性与教训。',
    time: '本周专题',
    read: '连载 3 期',
    author: '专题组',
    image:
      'https://readdy.ai/api/search-image?query=stacked%20newspapers%20and%20magnifying%20glass%20on%20warm%20wooden%20desk%2C%20investigative%20journalism%20concept%2C%20editorial%20photography%20warm%20tone&width=880&height=560&seq=topic1-2026-1&orientation=landscape',
  },
  {
    id: 'topic-2',
    category: '吃瓜话题',
    tag: '#内娱浮世绘',
    title: '内娱浮世绘：镜头内外，一部行业的众生相',
    summary:
      '从台前到幕后，从资本到素人，用一篇篇人物特稿拼出一张行业全景图，带你看见热搜之外的真实生态。',
    time: '长期专题',
    read: '连载 12 期',
    author: '追瓜组',
    image:
      'https://readdy.ai/api/search-image?query=theater%20stage%20curtains%20and%20spotlights%20silhouette%2C%20dramatic%20warm%20golden%20lighting%2C%20editorial%20concept%20photography&width=880&height=560&seq=topic2-2026-1&orientation=landscape',
  },
];

export const latestFeed = [
  { time: '刚刚', tag: '快讯', text: '某平台宣布加强内容审核，将重点治理无证据“爆料”贴' },
  { time: '16 分钟前', tag: '快讯', text: '一场红毯礼延迟一小时开场，主办方就位次安排致歉' },
  { time: '42 分钟前', tag: '快讯', text: '业内人士谈演唱会实名制：真黄牛并未消失，只是换了玩法' },
  { time: '1 小时前', tag: '快讯', text: '多家影视公司发布财报，精品短剧成为新增量' },
  { time: '2 小时前', tag: '快讯', text: '被热议的“剧组打戏受伤”话题，当事人发文澄清并致谢' },
  { time: '3 小时前', tag: '快讯', text: '短视频平台推出“创作者事实核查”新功能试点' },
];

export const principles = [
  { icon: 'ri-scales-3-line', title: '多方求证', desc: '重要事实不采信单一信源，尽量交叉核验原始材料与当事方回应。' },
  { icon: 'ri-eye-line', title: '区分事实与观点', desc: '报道中明确标注哪些是已核实事实、哪些是各方立场与推断。' },
  { icon: 'ri-heart-pulse-line', title: '少一点围观伤害', desc: '关注事件的公共价值，克制对个人隐私与无关当事人的过度挖掘。' },
  { icon: 'ri-edit-2-line', title: '有错必纠', desc: '如报道出现偏差，第一时间更正并说明，接受读者监督与指正。' },
];

export const testimonials = [
  { name: '一位文娱行业从业者', text: '看腻了情绪化的标题党，吃瓜新闻会认真把事件的时间线讲清楚，行业里的细节也比较真实。', role: '读者反馈' },
  { name: '关注行业多年的老读者', text: '很少有一家号愿意去追问“翻车”背后的机制，而不是单纯站队起哄。', role: '长文评论' },
  { name: '新闻系在读学生', text: '把很多热点拆解成可学的案例，比教科书更鲜活，很适合入门传媒写作。', role: '私信留言' },
];

export const stats = [
  { value: '4800+', label: '累计深度报道' },
  { value: '1200+', label: '独家人物专访' },
  { value: '360w', label: '全网粉丝关注' },
  { value: '6', label: '常设内容栏目' },
];

export const faqs = [
  {
    q: '吃瓜新闻是严肃媒体吗？还是娱乐八卦号？',
    a: '我们定位为以热点为入口的深度内容媒体。关注娱乐、社会与行业话题中具有公共价值的部分，追求把事件讲清楚、把背景讲透，而不是单纯制造对立或情绪化站队。',
  },
  {
    q: '报道里的信息如何保证可信？',
    a: '重要事实要求多方信源交叉验证，并优先使用可查证的原始声明、公开资料与当事方回应。涉及推断的内容会明确标注为分析或观点，与事实分开呈现。',
  },
  {
    q: '你们会起底并公开普通人的隐私吗？',
    a: '不会。我们只围绕事件本身具有公共性的部分展开，克制对事件无关个人隐私、家庭住址、联系方式等信息的挖掘与传播，这也是团队的基本编辑准则。',
  },
  {
    q: '发现报道有误，该如何反馈？',
    a: '可通过页面底部的编辑部邮箱与我们联系，请注明稿件标题与具体出入之处。核实后我们会第一时间更正，并在原文标注说明，欢迎读者监督。',
  },
  {
    q: '可以投稿或提供线索吗？',
    a: '欢迎从业者与知情读者提供线索。投稿请发送至编辑邮箱，邮件中简要说明主题与可提供的一手材料，我们会评估后与您联系，并对信源信息严格保密。',
  },
];